import { useHeaderSearchRecents } from "./useHeaderSearchRecents";

/** Keeps header-search writes alive on the search page, where the recents panel is hidden. */
const HeaderSearchRecentsRecorder = () => {
  useHeaderSearchRecents();
  return null;
};

export default HeaderSearchRecentsRecorder;
